export const APP_HEADER_NAV_ITEMS = [
  {
    key: 'meldingen',
    group: 'workspace',
    label: 'Meldingen',
    getPath: () => '/meldingen',
    isActive: ({ locationPath }) => locationPath === '/meldingen',
    badgeKey: 'meldingenBadgeCount',
  },
  {
    key: 'analytics',
    group: 'workspace',
    label: 'Analytics',
    getPath: () => '/analytics',
    isActive: ({ locationPath }) => locationPath.startsWith('/analytics') || locationPath.startsWith('/ana'),
    submenu: [
      { key: 'analytics-dashboard', label: 'Dashboard', path: '/analytics' },
      { key: 'analytics-dossier', label: 'Robot Performance Dossier', path: '/analytics/rpd-manager' },
      { key: 'analytics-operational', label: 'Operationele intelligentie', path: '/analytics/operational' },
      { key: 'analytics-comparisons', label: 'Vergelijkingen', path: '/analytics/average' },
      { key: 'analytics-exports', label: 'Exports', path: '/analytics/robots' },
      { key: 'analytics-scoreboard', label: 'Scoreboard', path: '/scoreboard' },
    ],
  },
  {
    key: 'technician',
    group: 'workspace',
    label: 'Technicuskaart',
    getPath: () => '/technician',
    isActive: ({ locationPath }) => locationPath === '/technician' || locationPath === '/technician-map',
  },
  {
    key: 'profile',
    group: 'account',
    label: 'Profiel',
    getPath: () => '/profile',
    isActive: ({ locationPath }) => locationPath === '/profile',
  },
  {
    key: 'bijzonderheden',
    group: 'operations',
    label: 'Bijzonderheden',
    getPath: () => '/bijzonderheden',
    isActive: ({ locationPath }) => locationPath === '/bijzonderheden',
    isVisible: ({ canAccessBijzonderheden }) => canAccessBijzonderheden,
  },
  {
    key: 'administratie',
    group: 'operations',
    label: 'Administratie',
    getPath: ({ adminHomePath = '/administratie' }) => adminHomePath,
    isActive: ({ locationPath }) => locationPath.startsWith('/administratie'),
    isVisible: ({ canAccessAdminNav }) => canAccessAdminNav,
    submenu: [
      { key: 'admin-meldingen', label: 'Meldingen', path: '/administratie/meldingen' },
      { key: 'admin-robots', label: 'Robots', path: '/administratie/robots' },
      { key: 'admin-robot-dossiers', label: 'Robot dossiers', path: '/administratie/robot-dossiers' },
      { key: 'admin-onderdelen', label: 'Onderdelen', path: '/administratie/onderdelen' },
      { key: 'admin-garanties', label: 'Garanties', path: '/administratie/garanties' },
      { key: 'admin-gebruikers', label: 'Gebruikers', path: '/administratie/gebruikers' },
      { key: 'admin-vestigingen', label: 'Vestigingen', path: '/administratie/vestigingen' },
      { key: 'admin-documentatie', label: 'Documentatie', path: '/administratie/documentatie' },
      { key: 'admin-checklists', label: 'Check-lists', path: '/administratie/check-lists' },
      { key: 'admin-portals', label: 'Portals', path: '/administratie/portals' },
      { key: 'admin-auditlog', label: 'Audit log', path: '/administratie/auditlog' },
      { key: 'admin-changelog', label: 'Changelog', path: '/administratie/changelog' },
      { key: 'admin-cycle-learning', label: 'Cycle Training', path: '/administratie/cycle-learning' },
      { key: 'admin-tickets', label: 'Tickets', path: '/administratie/tickets' },
    ],
  },
  {
    key: 'showroom',
    group: 'operations',
    label: ({ demoShowroomEnabled }) => (demoShowroomEnabled ? 'Showroom Live' : 'Showroom'),
    getPath: () => '/demo/showroom',
    isActive: ({ locationPath }) => locationPath === '/demo/showroom',
    isVisible: ({ demoModeEnabled }) => demoModeEnabled,
  },
];

export function getAppHeaderNavItems(context = {}) {
  return APP_HEADER_NAV_ITEMS
    .filter((item) => (typeof item.isVisible === 'function' ? item.isVisible(context) : true))
    .map((item) => ({
      key: item.key,
      group: item.group || 'workspace',
      label: typeof item.label === 'function' ? item.label(context) : item.label,
      path: item.getPath(context),
      active: item.isActive(context),
      badgeCount: item.badgeKey ? Number(context[item.badgeKey] || 0) : 0,
      submenu: Array.isArray(item.submenu) ? item.submenu : [],
    }));
}
